import React from "react";
import "../../Assets/css/paymentOptions.css";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Slide,
  Snackbar,
  Typography,
  CircularProgress,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import usePaymentPage from "./usePaymentOptions";
import CircularProgressBar from "../../Components/PersonalAccidentComponents/CircularProgressBar/CircularProgressBar";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function TransitionLeft(props) {
  return <Slide {...props} direction="left" />;
}

const PaymentOptionsPage = () => {
  const {
    transferData,
    sentSMS,
    checkPaymentStatus,
    nextButtonStatus,
    sendLinkButtonClicked,
    nextHandler,
    sendPaymentLinkToCustomer,
    msgForSMSButton,
    clickedPayHere,
    handleCloseSlack,
    handlePayHere,
    backButtonHandler,
    premiumAmount,
    grossPremiumAmount,
    serviceTaxAmount,
  } = usePaymentPage();

  return (
    <>
      <div>
        <div className="header-section">
          <p className="insurence-title-sec">
            Personal Accident Insurance
            <KeyboardArrowDownIcon />
          </p>
        </div>
        <Container
          style={{ marginTop: 10, marginBottom: 10 }}
          maxWidth="sm md lg"
        >
          <Card className="card-section" sx={{ minWidth: 275, marginTop: 5 }}>
            <Box sx={{ display: "flex", marginBottom: 4 }}>
              <img
                className="bg-white img-thumbnail rounded"
                width={100}
                height={100}
                src={transferData.logo}
                alt="company_logo"
              />
              <Box style={{ margin: 16 }}>
                <Typography>{transferData.vendor}</Typography>
                <Typography>{transferData.product_name}</Typography>
              </Box>
            </Box>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <Typography>Proposer Name:</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>
                    <strong>{transferData.proposerName}</strong>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography>Policy Type:</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>
                    <strong>
                      {transferData.number_of_insured > 1
                        ? "Floater"
                        : "Individual"}
                    </strong>
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography>Number of Insured(s):</Typography>
                </Grid>
                <Grid item xs={7}>
                  <Typography>{transferData.number_of_insured} </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography></Typography>
                </Grid>
                <hr />
                <Grid item xs={3}></Grid>
                <Grid item xs={6} color="text.primary" style={{}}>
                  <Typography>
                    <b>Premium Details</b>
                  </Typography>
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={8}>
                  <Typography>Policy Premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {premiumAmount || transferData.premium}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>Tax On Premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {serviceTaxAmount || transferData.serviceTax}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>Gross premium:</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>
                    <b className="rupee_symp">&#8377;</b>{" "}
                    {grossPremiumAmount || transferData.totalPremium}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <div className="button-section">
            {sentSMS ? (
              <div>
                <div>
                  <button
                    className="pay-btn"
                    type="button"
                    onClick={checkPaymentStatus}
                  >
                    Check Status
                  </button>
                </div>
                <div>
                  {nextButtonStatus && (
                    <button
                      className="payment-btn"
                      type="button"
                      onClick={nextHandler}
                    >
                      Next
                    </button>
                  )}
                </div>
              </div>
            ) : (
              <div>
                <div>
                  {sendLinkButtonClicked ? (
                    <Box
                      className="mx-auto"
                      style={{
                        display: "flex",
                        marginTop: "10px",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress
                        size={48}
                        sx={{
                          color: "red",
                        }}
                      />
                    </Box>
                  ) : (
                    <button
                      className="payment-btn"
                      type="button"
                      onClick={sendPaymentLinkToCustomer}
                      disabled={
                        msgForSMSButton === "A sms will be sent to the customer"
                          ? true
                          : false
                      }
                    >
                      {msgForSMSButton}
                    </button>
                  )}
                  <Snackbar
                    open={sendLinkButtonClicked}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    autoHideDuration={5000}
                    TransitionComponent={TransitionLeft}
                    onClose={handleCloseSlack}
                  >
                    <Alert severity="success" onClose={handleCloseSlack}>
                      {/* A sms will be sent to the customer */}
                      {msgForSMSButton}
                    </Alert>
                  </Snackbar>
                </div>
                <div>
                  {clickedPayHere ? (
                    <CircularProgressBar />
                  ) : (
                    <button
                      className="pay-btn "
                      type="button"
                      onClick={handlePayHere}
                    >
                      Pay here
                    </button>
                  )}
                </div>
              </div>
            )}

            <button
              className="back-btn"
              type="button"
              onClick={backButtonHandler}
            >
              Back
            </button>
          </div>
        </Container>
      </div>
    </>
  );
};

export default PaymentOptionsPage;
